import { createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/NotFound';

// A splat/catch-all leaf route, not `notFoundComponent` on the layout: a pathless
// route like `_auth` never becomes the router's fuzzy not-found boundary in
// practice, so an unmatched path here would otherwise bubble all the way to the
// root route, skipping this subtree's `beforeLoad` (and therefore its auth gate)
// entirely. Matching here as a real child keeps `beforeLoad` running as normal, so
// an expired session still renders `SessionExpiredEmptyState` instead of this page.
export const Route = createFileRoute('/system/_auth/$')({
    component: () => <NotFound kind="system" />,
});
